import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/stock-in-from-vendors', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/stock-in-from-vendors/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/stock-in-from-vendors', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
    return httpClient
      .put(`/api/v1/stock-in-from-vendors/${id}`, data)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
    return httpClient
      .delete(`/api/v1/stock-in-from-vendors/${id}`)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
}

export const returnToVendorList = () => {
    return httpClient
    .get('/api/v1/stock-in-from-vendors/return-to-vendors')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export const findReturnToVendorList = retunrToVendorId => {
    return httpClient
    .get(`/api/v1/stock-in-from-vendors/${retunrToVendorId}/return-to-vendors`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export default { 
    get, 
    find,
    store,
    update,
    destroy,
    returnToVendorList,
    findReturnToVendorList
}